function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useRef } from "react";
import { Tabs, notification, Skeleton, List, Modal, Button, DatePicker, Divider, Spin, Drawer, Space, Tag } from "antd";
import { ListUl, Cash, PrinterFill, CheckCircleFill, XCircleFill } from "react-bootstrap-icons";
import { Row, Col } from "react-bootstrap";
import moment from 'moment';
import Common from "../components/includes/Common";
import Moment from 'react-moment';
import DisplayInvoice from "./DisplayInvoice";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Abortbills = function Abortbills() {
  var ref = useRef();
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    refresh = _useState2[0],
    setRefresh = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    bills = _useState4[0],
    setBills = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    requestProcessing = _useState6[0],
    setRequestProcessing = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    payoutsDataChanged = _useState8[0],
    setPayoutsDataChanged = _useState8[1];
  var _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    billsDataError = _useState0[0],
    setBillsDataError = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isDataLoading = _useState10[0],
    setIsDataLoading = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedBill = _useState12[0],
    setSelectedBill = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showInvoice = _useState14[0],
    setShowInvoice = _useState14[1];
  var handleAccept = function handleAccept(b) {
    confirm({
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CheckCircleFill, {
          color: "#5D9843",
          size: 28
        }), " Acceptez-vous ?"]
      }),
      content: /*#__PURE__*/_jsxs("div", {
        children: ["L'annulation de la vente de produits pour ", b.total_amount, " ?"]
      }),
      onOk: function onOk() {
        setRequestProcessing(true);
        axios.post(Common.baseApiUrl + "acceptabort", {
          user_id: Common.currentUser.id,
          bill_id: b.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setRefresh(true);
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {
          setRequestProcessing(false);
        });
      },
      onCancel: function onCancel() {}
    });
  };
  var handleReject = function handleReject(b) {
    confirm({
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(XCircleFill, {
          color: "#B64D4D",
          size: 28
        }), " R\xE9fusez-vous ?"]
      }),
      content: /*#__PURE__*/_jsxs("div", {
        children: ["L'annulation de la vente de produits pour ", b.total_amount, " ?"]
      }),
      onOk: function onOk() {
        setRequestProcessing(true);
        axios.post(Common.baseApiUrl + "rejectabort", {
          user_id: Common.currentUser.id,
          bill_id: b.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {
          setRequestProcessing(false);
        });
      },
      onCancel: function onCancel() {}
    });
  };
  useEffect(function () {
    setRefresh(false);
    setPayoutsDataChanged(false);
    setIsDataLoading(true);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getrequestedabortions/").concat(Common.currentUser.id))]).then(function (response) {
      if (response[0].data.status == 200) {
        setBills(response[0].data.bills);
      } else {
        setBillsDataError(response[0].data.message);
      }
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [refresh]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [ContextHolder, /*#__PURE__*/_jsx(List, {
          loading: isDataLoading,
          itemLayout: "horizontal",
          dataSource: bills,
          renderItem: function renderItem(item) {
            return /*#__PURE__*/_jsx(List.Item, {
              actions: [/*#__PURE__*/_jsx(Button, {
                type: "default",
                disabled: item.state == 3 || item.state == 4,
                onClick: function onClick() {
                  handleAccept(item);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(CheckCircleFill, {
                    color: "#5D9843",
                    size: 18
                  })
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "default",
                disabled: item.state == 3 || item.state == 4,
                onClick: function onClick() {
                  handleReject(item);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(XCircleFill, {
                    color: "#DC6847",
                    size: 18
                  })
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setSelectedBill(item);
                  setShowInvoice(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(PrinterFill, {
                    size: 18
                  })
                })
              })],
              children: /*#__PURE__*/_jsx(Skeleton, {
                avatar: true,
                title: false,
                loading: isDataLoading,
                active: true,
                children: /*#__PURE__*/_jsx(List.Item.Meta, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: item.created_at,
                      format: "DD/MM/YYYY HH:mm"
                    })
                  }),
                  description: item.approver ? /*#__PURE__*/_jsxs(_Fragment, {
                    children: [item.state == 2 && /*#__PURE__*/_jsx(Tag, {
                      color: "#FCB814",
                      children: "En attente"
                    }), " ", item.state == 3 && /*#__PURE__*/_jsx(Tag, {
                      color: "#01AA6B",
                      children: "Accept\xE9"
                    }), " ", item.state == 4 && /*#__PURE__*/_jsx(Tag, {
                      color: "#B64D4D",
                      children: "Refus\xE9"
                    }), " ", " Montant : " + item.total_amount.toLocaleString("Fr") + "GNF , Payé: " + item.paid_amount.toLocaleString("Fr") + "GNF, Client: " + item.lead.name + "- Agent approbateur : " + item.approver.prenom + " " + item.approver.nom]
                  }) : /*#__PURE__*/_jsxs(_Fragment, {
                    children: [item.state == 2 && /*#__PURE__*/_jsx(Tag, {
                      color: "#FCB814",
                      children: "En attente"
                    }), " ", item.state == 3 && /*#__PURE__*/_jsx(Tag, {
                      color: "#01AA6B",
                      children: "Accept\xE9"
                    }), " ", item.state == 4 && /*#__PURE__*/_jsx(Tag, {
                      color: "#B64D4D",
                      children: "Refus\xE9"
                    }), " ", " Montant : " + item.total_amount.toLocaleString("Fr") + "GNF , Payé: " + item.paid_amount.toLocaleString("Fr") + "GNF, Client: " + item.lead.name]
                  })
                })
              })
            });
          }
        })]
      })
    }), selectedBill && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS DEVIS"
        }),
        width: "80%",
        open: showInvoice,
        onClose: function onClose() {
          setShowInvoice(false);
        },
        destroyOnClose: true,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref) {
                var handlePrint = _ref.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  onClick: handlePrint,
                  type: "ghost",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "IMPRIMER"
                  })
                });
              }
            })
          })
        }),
        children: /*#__PURE__*/_jsx(DisplayInvoice, {
          ref: ref,
          invoice: selectedBill
        })
      })
    })]
  });
};
export default Abortbills;